// extracted by mini-css-extract-plugin
export default {"pageContent":"EventPage_pageContent__lDbXg"};